import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Grid from '@mui/material/Grid';

const s:any = {
  grid: {
    minHeight: '60vh',
  },
};

class CenterGrid extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;

  render() {
    const {xs=12,sm=12,children,classes} = this.props;
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{...s.grid}}
      >
        <Grid size={{xs:xs,sm:sm}}>
          {children}
        </Grid>   
      </Grid> 
    );
  }
}

CenterGrid.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default CenterGrid;
